import { defineRule } from 'vee-validate'
import { i18n } from '@/i18n.js'
import moment from 'moment'

defineRule('date_between', (value, dates) => {
  if (!value || value === '') {
    return true
  }

  const min = dates[0]
  const max = dates[1]
  let currentDate = moment(value, ['YYYY-MM-DD'])
  let today = moment()
  let d1
  let d2

  if (min === 'now') {
    d1 = today
  } else if (min.includes('now-')) {
    const nbDays = min.split('-')[1]
    d1 = today.clone().subtract(nbDays, 'days')
  } else if (min.includes('now+')) {
    const nbDays = min.split('+')[1]
    d1 = today.clone().add(nbDays, 'days')
  } else {
    d1 = moment(min)
  }

  if (max === 'now') {
    d2 = today
  } else if (max.includes('now-')) {
    const nbDays = max.split('-')[1]
    d2 = today.clone().subtract(nbDays, 'days')
  } else if (max.includes('now+')) {
    const nbDays = max.split('+')[1]
    d2 = today.clone().add(nbDays, 'days')
  } else {
    d2 = moment(max)
  }

  if (currentDate.isBetween(d1, d2, null, '[]')) {
    return true
  }
  return `${i18n.global.t('form.min_date')}: ${d1.format('L')} / ${i18n.global.t('form.max_date')}: ${d2.format('L')}`
})
